import { Route, useHistory } from "react-router-dom";
import { useEffect } from "react";

const RouteEnforcer = ({ computedMatch, location, children }) => {
	const history = useHistory();

	useEffect(() => {
		if (computedMatch && computedMatch.isExact === false) {
			history.replace(computedMatch.url + location.search + location.hash);
		}
	}, [computedMatch, location, history]);

	return children;
};

export const Routes = (route) => {
	return (
		<Route
			path={route.path}
			render={(props) => (
				<RouteEnforcer
					computedMatch={props.match}
					location={props.location}
				>
					<route.component {...props} routes={route.routes} />
				</RouteEnforcer>
			)}
		/>
	);
};
